import { IFooter } from '@interfaces';
import React from 'react';
import { FooterBottom } from './FooterBottom';
import { NewsletterFooter } from '../newsletter-footer/NewsletterFooter';
import { FooterNav } from './FooterNav';
import { FooterStickyMobile } from './FooterStickyMobile';
import { FooterStickyMobileB } from './FooterStickyMobileB';
import { FooterUSP } from './FooterUSP';
import { FooterContactForm } from './FooterContactForm';

export class Footer extends React.Component<IFooter, {}> {
    public render() {
        return (
            <div>
                <footer className="footer">
                    {this.props.showFooterNewsletterInput && (
                        <>
                            {this.props.isNewsletterNew ? (
                                <NewsletterFooter deviceType="desktop" type={this.props.type} />
                            ) : (
                                <FooterContactForm {...this.props.contactForm} />
                            )}
                        </>
                    )}
                    <FooterUSP />
                    <FooterNav footer={this.props} />
                    <FooterBottom className="footer_bottomBar" list={this.props.bottom} />
                </footer>
                <FooterStickyMobile />
                <FooterStickyMobileB />
            </div>
        );
    }
}
